export default {
  authMessage: 'Connectez-vous avant de continuer',
  errorMessage: 'Une erreur est apparue, dirigez-vous vers notre page Nous joindre.',
  errorMessageDublicate: 'Veuillez noter qu\'une réservation avec le meme identifiant a été détectée et qu\'aucune réservation ne peut donc être effectuée. Pour de plus amples informations, veuillez nous contacter.',
  errorMessageValidationOPUS: 'Numéro de carte OPUS invalide.',
  errorMessageValidationName: 'Les champs Prénom et Nom ne peuvent contenir aucun caractère spécial',
  errorMessageCodeError: 'Le code est incorrect, veuillez essayer à nouveau',
  paymentDescription: 'Le mode de paiement sera vérifié par le chauffeur dans le véhicule.', 
  note: {
    label: 'Inscrire votre arrêt sur demande ici',
    content: 'Contenu',
  }
};
